import "./NoContent.css";
import type { ComponentProps } from "react";

interface NoContentProps extends ComponentProps<"div"> {
  label: string;
  sublabel: string;
  image: string;
}

export function NoContent(props: NoContentProps) {
  const { image, label, sublabel, ...rest } = props;
  return (
    <div className="no-content">
      <img draggable="false" src={image} alt={label} />
      <div className="labels">
        <div>{label}</div>
        <div>{sublabel}</div>
      </div>
      <div {...rest}>{props.children}</div>
    </div>
  );
}
